// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

// The shipment audit operations the frontend renders differently. These mirror
// the backend StateTrigger values in src/enums/event.go — a rename there must be
// made here too, or the copy silently degrades to the generic wording rather
// than failing.
export const SHIPMENT_AUDIT_OPERATIONS = {
  CREATE: 'SHIPMENT_CREATE',
  PENDING_SERIALS_UPDATE: 'SHIPMENT_PENDING_SERIALS_UPDATE',
} as const;
